import { useCallback } from 'react';
import { getGuestRouteRedirect, shouldRenderGuestChildren } from 'utils/authNavigation';
import { useAuthSession } from 'hooks/useAuthSession';
import { useAuthRedirect } from 'hooks/useAuthRedirect';

/**
 * Blocks fully authenticated users from guest-only pages (login, register, etc.).
 * Routes incomplete sessions via centralized auth navigation (prod parity).
 */
export default function GuestRoute({ children }) {
  const session = useAuthSession();
  const resolveRedirect = useCallback((s) => getGuestRouteRedirect(s), []);

  useAuthRedirect(resolveRedirect);

  if (!shouldRenderGuestChildren(session)) {
    return null;
  }

  return children;
}
